import { useShowContext } from "ra-core";
import type { Contact } from "@/components/atomic-crm/types";
import { ContactShowActions } from "@/modules/contacts/ContactShowActions";
import { ContactRecordView } from "@/modules/clients/record/RecordViews";

/**
 * Contact record. Full page: fields and account on the left, tabs on the
 * right. Embedded (side panel): Home | Timeline | Tasks | More.
 */
export const ContactShowContent = ({
  embedded = false,
  onClose,
}: {
  embedded?: boolean;
  onClose?: () => void;
} = {}) => {
  const { record, isPending, refetch } = useShowContext<Contact>();
  if (isPending || !record) return null;

  return (
    <div className={embedded ? "h-full min-h-0" : "lg:h-full lg:min-h-0"}>
      {embedded ? null : (
        <ContactShowActions
          record={record}
          onContactUpdated={() => void refetch()}
        />
      )}
      <ContactRecordView
        record={record}
        mode={embedded ? "panel" : "page"}
        onClose={onClose}
      />
    </div>
  );
};
